import Vue from 'vue';
const state = {
  commandes: [],
};

const getters = {
  commandes: state => state.commandes,
};

const actions = {

  getCommandes({ commit }, filtres) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/commandes',{params: filtres}).then(response => {
        commit('setCommandes', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getCommandesExcel({ commit }, filtres) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/commande/excelExport',{responseType:'blob', params:filtres}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'commandes_'+new Date().toLocaleDateString()+'.xlsx');
        document.body.appendChild(link);
        link.click();
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  loadCommande({ commit }, id) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/commandes/'+id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getCommande({ commit }, id) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/commande/'+id+'/etat').then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  exportDestinataires({ commit }, {commandeId, filter = 'all'}) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/exportDestinataires/'+commandeId+'?filter='+filter, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'destinataires_commande_'+commandeId+'.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {document.body.removeChild(link)},1000);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  exporFicheTravailSyndic({ commit }, {commandeId}) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/ficheSyndic/'+commandeId, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(
          new Blob(
            [response.data],
            {type:'application/vnd.openxmlformats-officedocument.wordprocessingml.document'}
          )
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'fiche_syndic_'+commandeId+'.docx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {document.body.removeChild(link)},1000);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  exportDestinatairesPrepaFacile({ commit }, commandeId) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/exportDestinatairesPrepaFacile/'+commandeId, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'destinataires_commande_'+commandeId+'.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {document.body.removeChild(link)},1000);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  downloadAll({ commit }, commandeId) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/downloadAll/'+commandeId, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'fichiers_'+commandeId+'.zip'); //or any other extension
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {document.body.removeChild(link)},1000);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  checkCommande({ commit }, commande) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/letreco/check',{commande_id: commande.id}).then(response => {
        resolve(response);
      }).catch(error => {
      });
    });
  },

  getAcquittement({ commit }, params) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/letreco/ack',params,{responseType: 'arraybuffer'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data],{type:"application/pdf"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'acquittement_'+params.reference+'.pdf');
        document.body.appendChild(link);
        link.click();
        resolve(response);
      }).catch(error => {
        Vue.toasted.global.expedium_error({
            message : 'Erreur lors du telechargement de l\'acquittement: '+error.response.data.message+' erreur: '+error.response.status
        });
        reject(error);
      });
    });
  },

  updateDestinataires({ commit }, commande) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/commande/'+commande.id+'/destinataires',{destinataires:commande.commande_destinataires}).then(response => {
        resolve(response);
      }).catch(error => {
        Vue.toasted.global.expedium_error({
            message : 'Erreur lors de la maj destinataires: '+error.response.data.message+' erreur: '+error.response.status
        });
        reject(error);
      });
    });
  },

  supprimerCommande({ commit }, {commande, callerComponent}) {
    return new Promise((resolve, reject) => {
      callerComponent.$bvModal.msgBoxConfirm('Cetta action supprimera définitivement la commande.', {
        title: 'Suppression de la commande',
        size: 'lg',
        okVariant: 'danger',
        okTitle: 'Oui, je veux supprimer la commande',
        cancelTitle: 'Non',
        footerClass: 'p-2',
        bodyClass: 'p-2 text-center h2',
        hideHeaderClose: false,
        centered: true
      })
      .then(accepted => {
        if(accepted) {
          window.axios.delete('/api/commandes/'+commande.id).then(response => {
            resolve(true);
          }).catch(error => {
            Vue.toasted.global.expedium_error({
                message : 'Erreur lors de la suppression : '+error.response.data.message+' erreur: '+error.response.status
            });
            reject(error);
          });
        } else {
          resolve(false);
        }
      })
      .catch(err => {
        console.log("error", err)
        resolve(false);
      })
    })
  },

  getDepositProof({ commit }, reference) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/letreco/proof',{reference:reference}, {responseType: 'arraybuffer'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'preuve_dépot_'+reference+'.pdf');
        document.body.appendChild(link);
        link.click();
        resolve(response);
      }).catch(error => {
        Vue.toasted.global.expedium_error({
            message : 'Erreur lors du telechargement de la preuve: '+error.response.data.message+' erreur: '+error.response.status
        });
        reject(error);
      });
    });
  },

  getDepositProofPrepaFacile({ commit }, commande) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/commande/'+commande.id+'/proof',{}, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'preuve_de_depot_'+commande.numero+'.pdf');
        document.body.appendChild(link);
        link.click();
        resolve(response);
      }).catch(error => {
        Vue.toasted.global.expedium_error({
            message : 'Erreur lors du telechargement de la preuve: '+error.response.data.message+' erreur: '+error.response.status
        });
        reject(error);
      });
    });
  },

  getARPrepaFacile({ commit }, dest) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/destinataire/'+dest.id+'/ar',{}, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', dest.ar_pdf);
        document.body.appendChild(link);
        link.click();
        resolve(response);
      }).catch(error => {
        Vue.toasted.global.expedium_error({
            message : 'Erreur lors du telechargement de l\'AR: '+error.response.data.message+' erreur: '+error.response.status
        });
        reject(error);
      });
    });
  },

  parsePDF({
    commit
  }, {formData, commande}) {
    commit('setFileUploading', true)
    return new Promise((resolve, reject) => {
        window.axios.post('/api/commande/'+commande.id+'/parsePDF', formData).then(response => {
            commit('setFileUploading', false)
            resolve(response);
        }).catch(error => {
            Vue.toasted.global.expedium_error({
                message : 'Une erreur est survenue. Si le problème persiste veuillez contacter nos services de 8h à 18h du lundi au vendredi. (code erreur : '+error.response.data.message+')'
            });
            commit('setFileUploading', false)
        });
    });
  },

};

const mutations = {
  setCommandes(state, commandes) {
    state.commandes = commandes;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};